import produce from "immer"
import { DESC } from "const"
import { MtProject } from "server/models"
import { InferValueTypes } from "client/utils"
import { initProjectSettings } from "client/store"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initProject: MtProject = {
    id: null,
    accountId: null,
    publicId: "",
    name: "",
    description: "",
    documentId: "",
    logoId: null,
    logo: null,
    owner: null,
    modules: null,
}

const initProjectState: types.ProjectState = {
    projectList: {},
    projectIds: [],
    projectView: initProject,
    projectEdit: initProject,

    projectSettings: initProjectSettings,

    sortColumn: "createdAt",
    sortOrder: DESC,
    filters: {
        owner: null,
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const projectReducer = produce((
    draft: types.ProjectState = initProjectState,
    action: ActionTypes = null,
): types.ProjectState => {
    switch (action.type) {
        case types.PROJECT_LIST:
            draft.projectList = action.projectList
            return draft

        case types.PROJECT_IDS:
            draft.projectIds = action.projectIds
            return draft

        case types.PROJECT_VIEW:
            draft.projectView = action.project
            return draft

        case types.PROJECT_EDIT:
            draft.projectEdit = action.project
            return draft

        case types.PROJECT_PROJECT_SETTINGS:
            draft.projectSettings = action.settings
            return draft

        case types.PROJECT_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.PROJECT_FILTERS:
            draft.filters = action.filters
            return draft

        case types.PROJECT_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.PROJECT_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.PROJECT_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default projectReducer
